import { AppLogout } from '../AppLogout/AppLogout'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const SecuredHIPAAPageElem = ({ pageComponent }) => {
  return <AppLogout>{pageComponent}</AppLogout>
}
